
import { productData } from '../../../mocks/products';

export default function ComparisonTable() {
  const models = ['core', 'pro', 'style'] as const;

  const comparisonData = [
    {
      category: '基本情報',
      items: [
        { label: '製品名', values: models.map(m => productData[m].fullName) },
        { label: 'コンセプト', values: models.map(m => productData[m].label) },
        { label: '価格', values: models.map(m => `¥${productData[m].price.toLocaleString()}`) },
        { label: '対象ユーザー', values: models.map(m => productData[m].targetUser) },
      ],
    },
    {
      category: '機能・性能',
      items: [
        { label: '座面高さ', values: models.map(m => productData[m].specs.find(s => s.label === '座面高さ')?.value || '-') },
        { label: 'アームレスト', values: models.map(m => productData[m].specs.find(s => s.label === 'アームレスト')?.value || '-') },
        { label: 'リクライニング', values: models.map(m => productData[m].specs.find(s => s.label === 'リクライニング')?.value || '-') },
        { label: '耐荷重', values: models.map(m => productData[m].specs.find(s => s.label === '耐荷重')?.value || '-') },
        { label: '保証期間', values: models.map(m => productData[m].specs.find(s => s.label === '保証期間')?.value || '-') },
      ],
    },
    {
      category: '特徴',
      items: [
        { label: '主な特徴', values: models.map(m => productData[m].features[0].title) },
        { label: '最適な用途', values: ['標準デスクワーク', '電動昇降デスク', 'バランスボール代替'] },
        { label: '導入実績', values: ['中堅IT企業', '在日米軍基地', 'favy新宿'] },
      ],
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#f5f3ef] via-white to-[#f5f3ef]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#1a2332]/5 px-4 py-2 rounded-full mb-4">
            <i className="ri-table-line text-[#1a2332]"></i>
            <span className="text-xs font-bold text-[#1a2332] tracking-wider">DETAILED COMPARISON</span>
          </div>
          <h2 className="text-3xl font-bold text-[#1a2332]" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            詳細スペック比較表
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-[#1a2332]">
                  <th className="px-6 py-4 text-left text-sm font-bold text-white whitespace-nowrap">項目</th>
                  {models.map((modelKey) => (
                    <th
                      key={modelKey}
                      className="px-6 py-4 text-center text-sm font-bold text-white whitespace-nowrap"
                      style={{ backgroundColor: productData[modelKey].color }}
                    >
                      {productData[modelKey].fullName}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((category, catIdx) => (
                  <>
                    <tr key={`cat-${catIdx}`} className="bg-[#f5f3ef]">
                      <td colSpan={4} className="px-6 py-3 text-sm font-bold text-[#1a2332]">
                        {category.category}
                      </td>
                    </tr>
                    {category.items.map((item, itemIdx) => (
                      <tr key={`item-${catIdx}-${itemIdx}`} className="border-b border-[#e8e6e3] hover:bg-[#f5f3ef]/30 transition-colors">
                        <td className="px-6 py-4 text-sm font-medium text-[#1a2332] whitespace-nowrap">
                          {item.label}
                        </td>
                        {item.values.map((value, valIdx) => (
                          <td key={valIdx} className="px-6 py-4 text-sm text-[#4a4a4a] text-center">
                            {value}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-[#4a4a4a]">
            <i className="ri-information-line mr-1"></i>
            詳細な仕様や導入事例については、各製品ページをご覧ください
          </p>
        </div>
      </div>
    </section>
  );
}
